<template>
  <div>
    <div class="scroll-wrap">
      <!-- <div ref="scrollContainer" v-infinite-scroll.stop="loadMoreData" infinite-scroll-distance="10" v-if="listData.length > 0"> -->
      <div ref="scrollContainer" class="scroll-container">
        <template v-if="listData.length > 0">
          <div v-for="(item, index) in listData" :key="item.id" @click="handleClick(item)">
            <Item :itemData="item" :msgType="msgType" ></Item>
          </div>
          <div class="scroll-end" v-if="this.queObj.current >= this.totalPage">{{ $t('message.end') }}</div>
        </template>
        <div v-else style="" class="empty-wrap">
          <div class="empty-title">{{ msgType === 1 ? $t('message.noMessages') : $t('message.noTodo') }}</div>
          <div>{{ msgType === 1 ? $t('message.noMessagesTip') : $t('message.noTodoTip') }}</div>
        </div>
      </div>
    </div>
    <div class="opt-wrap" v-if="msgType == 1 && countObj.unReadCount && countObj.unReadCount > 0">
      <lls-button type="text" @click="handleReadAll">{{ $t('message.markAllAsRead') }}</lls-button>
    </div>
    <slot></slot>
    <lls-dialog
      :visible.sync="dialogVisible"
      width="640px"
      :append-to-body="true"
      class="detail-dialog"
    >
      <Detail 
        :itemData="currentItem" 
        :msgType="msgType" 
        @handleMarkDone="handleMarkDone"
      >
      </Detail>
    </lls-dialog>
  </div>
</template>

<script>
import Item from './Item.vue'
import _ from 'lodash';
import Detail from './Detail.vue';
import { isUnRead, dur } from '../func.js'
import dayjs from 'dayjs';
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: {
    msgType: {
      default: 1, // 1-Message 2-todo
      type: Number
    },
    countObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      listData: [],
      totalPage: 1,
      queObj: {
        current: 0,
        size: 10,
        queryCondition: {
          title: '',
          msgType: 1
        }
      },
      dialogVisible: false,
      currentItem: {},
      isZh: this.$i18n.locale == 'zh'
    }
  },
  computed: mapState([
    'updateMessageCount'
  ]),
  watch: {
    // vuex 监听待办数量，发生变化后自动刷新列表
    updateMessageCount(val) {
      this.listData = [] // 重置
      this.queObj.current = 0  // 重置
      this.loadMoreData() // 刷新页面
      this.$emit('refreshCount') // 更新待办数量
    }
  },
  components: {
    Item,
    Detail
  },
  methods: {
    isUnRead() {
      const a = isUnRead(...arguments, this.msgType)
      return a
    },
    handleClick(item) {
      // this.currentItem = item; 
      if (this.isZh) {
        this.currentItem =  {
          ...item,
          title: item.titleCn,
          content: item.contentCn
        }
      } else {
        this.currentItem = item
      }
      this.dialogVisible = true
      if (this.msgType === 1 && this.isUnRead(item)) { // message 点击就是已读
        // 读，全部读or办理   1:已读 2:已全部读 3:已办理
        this.fetchMarkedMsg(item.id, 1)
      } 
    },
     // 处理 to do
     async handleMarkDone(currentRow) {
      // 读，全部读or办理   1:已读 2:已全部读 3:已办理
      const flag = await this.fetchMarkedMsg(currentRow.id, 3)
      if (flag) {
        this.dialogVisible = false
      }
    },
    // 全选
    handleReadAll() {
      this.fetchMarkedMsg(null, 2)

    },
    async loadMoreData() {
        // 加载更多数据的逻辑
      // 这里模拟从API获取更多数据，实际应用中应该调用真实的API
      this.queObj.current++;
      if (this.queObj.current <= this.totalPage) {
        const newData = await this.fetchData()
        if (this.queObj.current == 1) {
          this.listData = [] // 重置
        }
        this.listData = this.listData.concat(newData)
      }
    },
    async fetchData() {
      const params = {
        ...this.queObj,
      }


      params.queryCondition.msgType = this.msgType   // 2.todo(待办)  1.message（消息通知）

      let res = await this.$API.system.queryNotificationList(params)

      let code = res.data.code;

      if (code == "200") {
        const data = res.data.data
        let tableData = data.records || []
        tableData = tableData.map(item => {
          return {
            ...item,
            originCreateTime: item.createTime,
            createTime: dur(item.createTime)
          }
        })
        console.log('tableData', tableData)
        // this.queObj.pageSize = size;
        this.totalPage = Number(data.pages) || 0;

        return tableData
      }
      return []
    },
    async fetchMarkedMsg(id, updType) {
      let params = {
        id,
        updType // 读，全部读or办理   1:已读 2:已全部读 3:已办理
      }
      // 自行处理错误信息
      try {
        const data = await this.$API.system.updateHandleStatus(params)

        var code = data.data.code;
        if (code == "200") {
          // 点击单行不提示成功
          if (updType !== 1) {
            this.$message({
              type: 'success',
              message: 'success',
              customClass: 'custom-message',
            });
          }
  
          return true
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: err,
          customClass: 'custom-message',
        });
      }
    },
    
    checkScroll() {
        const container = this.$refs.scrollContainer;
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        const scrollHeight = container.scrollHeight;
   
        if (scrollTop + clientHeight + 50 >= scrollHeight) {
          this.loadMoreData();
        }
    }
  },

  mounted() {
    // 初始化时加载第一页数据
    this.loadMoreData();
    const container = this.$refs.scrollContainer;
    container.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    const container = this.$refs.scrollContainer;
    container.removeEventListener('scroll', this.checkScroll);
  }
}
</script>

<style scoped lang="scss">

.btn-wrap {
  display: flex;
  float: right;
  font-size: 14px;

  .lls-webbtn {
    font-size: 14px;
  }
}

.pagination-wrap {
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  align-items: center;
  height: 68px;
}

.tag-primary {
  border-radius: 5px;
  font-weight: 400;
  color: #5A9CF8;
  // background-color: rgba(163, 201, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 30px;
}

.submit-btn {
  height: 28px;
  border-radius: 25px;
  background: linear-gradient(75.35deg, #5a9cf8 16.14%, #90befd 100%);
  border: 1px solid rgba(90, 156, 248, 0.5);
}

::v-deep {
  .lls-table .warning-row {
    background: oldlace;
  }

  .lls-table .success-row {
    background: rgb(163 201 255 / 40%);
  }
}

.detail-wrap {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 510px;
  margin: 50px auto;
  color: #7A7A7A;
}

.detail-type {
  font-size: 18px;
  color: #4E78B1;
  text-align: center;
  font-weight: 700;
}

.detail-title {
  color: #262626;
  font-size: 16px;
  font-weight: 600;
}

.dialog-btn-wrap {
  display: flex;
  justify-content: center;

}

.markdown-body {

  // border: 1px solid gray;
  li:before {
    content: normal;
    /* 这种样式会隐藏序号 */
  }
}

.clamp-two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 20px;
}

.content-sty ::v-deep {
  * {
    font-size: 14px !important;
    font-weight: 400 !important;
  }
}

.markdown-body {

  ol,
  ul {
    list-style: auto;
  }
}

.fixed-row-table ::v-deep {
  .lls-table__body {
    tr {
      height: 50px;
      /* 自定义行高 */
      cursor: pointer;
    }

    td {
      padding: 0;
    }
  }

  th {
    padding: 5px 0;
  }
}

.mavon-sty {
  box-shadow: none !important;
  max-height: calc(70vh - 120px);
  word-break: break-word;

  ::v-deep {
    .v-show-content {
      background-color: #fff !important;
      padding: 10px 0 !important;
    }
  }
}

.detail-dialog {
  display: flex;
  align-items: center;
  z-index: 9999 !important;
  ::v-deep {
    .lls-dialog {
      margin: 0 auto !important;
    }
  }
}

.level-0 {
  background: #F76C5E;
  color: #fff;
}

.level-1 {
  background: #FDB812;
  color: #fff;
}

.level-2 {
  background: #06D6A0;
  color: #fff;
}
.scroll-wrap, .scroll-container {
  height: 100%;
  overflow: auto;
  color: #262626;
  height: calc(100vh - 188px);
}
.scroll-end {
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  color: #999;
}
.opt-wrap {
  text-align: right;
  border-top: 1px solid #E2E8F0;
  padding: 16px;
  display: flex;
  flex-direction: row-reverse;
}
.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #999;
  margin-top: 35%
}
.empty-title {
  color: #89929E;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
}
</style>